// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox__1Z-f7","inovoice":"inovoice__3WXX1","link":"link__2ouq-"};